import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, Grid, Tab, Tabs, Typography} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import {useMemo, memo, useCallback} from "react";
import DraggableDialogTitle from "../common/DraggableDialogTitle";
import { ExtraSmallButton } from "../custom";
import { useSelector } from "react-redux";
import { selectUserPreferences } from "../../selectors/user";
import { updateUserPreferences } from "../../services/apis/user";

export type ConfigurationPopupProps = {
    open: boolean
    onClose: () => void
}

const PayoffSettingsDialog: React.FC<ConfigurationPopupProps> = ({ open, onClose }) => {
    const userPreferences = useSelector(selectUserPreferences)
    const { payOffSettings } = userPreferences
    const { showSdLines = true, showOiBars = true } = payOffSettings ?? {}
    const tabs = useMemo(() => (
        <Tabs value="settings" sx={{ width: '100%', overflowX: 'auto', display: 'flex' }}>
            <Tab label="Show/Hide" value="settings" />
        </Tabs>
    ), [])

    const handleSettingChange = useCallback(async (key: string, value: boolean) => {
            updateUserPreferences({
                body: {
                    payOffSettings: {
                        ...payOffSettings,
                        [key]: value
                    }
                }
            });
        }, [payOffSettings])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DraggableDialogTitle>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant={'h6'}>{"Payoff Settings"}</Typography>
                    <ExtraSmallButton color="inherit" onClick={onClose} aria-label="close"
                                sx={{ height: 'fit-content' }}>
                        <CloseOutlined />
                    </ExtraSmallButton>
                </Box>
                {tabs}
                <Divider />
            </DraggableDialogTitle>
            <DialogContent sx={{ width: '100%' }}>
                <Grid container direction={'column'} rowGap={1}>
                    <Grid gap={2} container sx={{ alignItems: 'center' }}>
                        <Grid item style={{ width: '120px' }}>SD Lines</Grid>
                        <Grid item xs={8}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    disableRipple={true}
                                    sx={{
                                        padding: 0
                                    }}
                                    checked={showSdLines}
                                    onChange={(e, checked) => {
                                        handleSettingChange('showSdLines', checked)
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid gap={2} container sx={{ alignItems: 'center' }}>
                        <Grid item style={{ width: '120px' }}>OI Bars</Grid>
                        <Grid item xs={8}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    disableRipple={true}
                                    sx={{
                                        padding: 0
                                    }}
                                    checked={showOiBars}
                                    onChange={(e, checked) => {
                                        handleSettingChange('showOiBars', checked)
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ borderTop: 1, borderColor: 'divider' }}>
                <Button variant="contained" onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default memo(PayoffSettingsDialog)